export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.deos.work/api'
// export const API_BASE_URL = 'http://localhost:5000/api'
